export default __webpack_public_path__ + "static/media/me-icon.3114040d.webp";